export default class HomeContent{
  name = 'home-page'
  title = `${this.name}.title`
  slug = 'home'
  description = `${this.name}.description`
  buttonText = `${this.name}.button-text`
}